import PropTypes from 'prop-types';

export const AddressShape = PropTypes.shape({

  firstName: PropTypes.string,
  lastName: PropTypes.string,
  addressLine1: PropTypes.string,
  addressLine2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip5: PropTypes.string,

  isDefault: PropTypes.bool,
  addressIdentifier: PropTypes.number,

});
